import React from 'react';
import PropTypes from 'prop-types';
import UrlDataReportsResult from './UrlDataReportsResult';
import './UrlDataReportsResults.scss';

const COLUMNS = ['', 'When', 'Reasons', 'Brand', 'Product', 'URL', 'Status', 'Assignee', ''];

const UrlDataReportsResults = ({ reports, loading, busyIds, onRequeue, onResolve, onDismiss, onClaim }) => {
  const renderBody = () => {
    if (loading && !reports.length) {
      return (
        <tr>
          <td colSpan={COLUMNS.length} className='udrr-empty'>
            Loading…
          </td>
        </tr>
      );
    }
    if (!reports.length) {
      return (
        <tr>
          <td colSpan={COLUMNS.length} className='udrr-empty'>
            No reports in this view.
          </td>
        </tr>
      );
    }
    return reports.map(report => (
      <UrlDataReportsResult
        key={report.id}
        report={report}
        busy={busyIds.has(report.id)}
        onRequeue={onRequeue}
        onResolve={onResolve}
        onDismiss={onDismiss}
        onClaim={onClaim}
      />
    ));
  };

  return (
    <div className='url-data-reports-results'>
      <table className='udrr-table'>
        <thead>
          <tr>
            {COLUMNS.map((column, idx) => (
              <th key={idx} className='udrr-th'>
                {column}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>{renderBody()}</tbody>
      </table>
    </div>
  );
};

UrlDataReportsResults.propTypes = {
  reports: PropTypes.arrayOf(PropTypes.object).isRequired,
  loading: PropTypes.bool.isRequired,
  busyIds: PropTypes.instanceOf(Set).isRequired,
  onRequeue: PropTypes.func.isRequired,
  onResolve: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
  onClaim: PropTypes.func.isRequired
};

export default UrlDataReportsResults;
